import { render, staticRenderFns } from "./ProfileSettingModal.vue?vue&type=template&id=5eceddae&scoped=true"
import script from "./ProfileSettingModal.vue?vue&type=script&lang=js"
export * from "./ProfileSettingModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eceddae",
  null
  
)

export default component.exports